import React, { useState, useEffect } from "react";
import { Link, navigate } from "gatsby";
import RevealAnimation from "../RevealAnimation";
import ArticleCard from "../featuredInsights/articleCard";
import Button from "../Button";
import DataService from "../../services/api/data_services";
import { renderRichText } from "../../shared/renderRichText";
import "../decor/_decorSquares.scss";
import "./style.scss";

const CaseStudiesSection = ({ caseStudies, disableDecor = false }) => {
  const enabled = caseStudies?.enabled;
  const {
    title,
    subtitle,
    description, // may be portable text blocks or string
    ctaText,
    ctaUrl,
    type = "clientStories", // Get type from caseStudies object
  } = caseStudies || {};

  // State for both client stories and articles
  const [clientStories, setClientStories] = useState([]);
  const [articles, setArticles] = useState([]);

  useEffect(() => {
    if (enabled) {
      if (type === "clientStories") {
        // Fetch client stories
        DataService.getData(
          "/admin/api/post?limit=3&page=1&page_id=1&type=Client Story&component=mini_view"
        )
          .then((res) => {
            setClientStories(res?.data || []);
          })
          .catch(() => {});
      } else if (type === "articles") {
        // Fetch articles
        DataService.getData(
          "/admin/api/post?limit=3&page=1&page_id=1&type=Article&component=mini_view"
        )
          .then((res) => {
            setArticles(res?.data || []);
          })
          .catch(() => {});
      }
    }
  }, [enabled, type]);

  const showClientStories =
    type === "clientStories" && clientStories.length > 0;
  const showArticles = type === "articles" && articles.length > 0;

  if (!enabled) return null;

  return (
    <section className="case-studies-section">
      {!disableDecor && (
        <div className="decor-squares" aria-hidden="true">
          <span className="decor-square" style={{ top: 34, left: "4%" }} />
          <span
            className="decor-square lg"
            style={{ top: "58%", right: "8%" }}
          />
          <span
            className="decor-square sm"
            style={{ bottom: 40, left: "12%" }}
          />
        </div>
      )}
      <div className="container">
        {(title || subtitle || description) && (
          <div className="section-header">
            {title && (
              <RevealAnimation>
                <h2 className="section-title">
                  {title.split(" ").map((word, index, arr) =>
                    index === arr.length - 1 ? (
                      <span key={index} className="title-highlight">
                        {word}
                      </span>
                    ) : (
                      `${word} `
                    )
                  )}
                </h2>
              </RevealAnimation>
            )}
            {subtitle && (
              <RevealAnimation delay={0.15}>
                <h4 className="section-description-alt">{subtitle}</h4>
              </RevealAnimation>
            )}
            {description && (
              <RevealAnimation delay={0.25}>
                <div className="section-subtitle rich-text">
                  {Array.isArray(description) || description?.[0]?.children
                    ? renderRichText(description)
                    : description}
                </div>
              </RevealAnimation>
            )}
          </div>
        )}

        {showClientStories && (
          <div className="client-stories-wrapper">
            <ArticleCard miniviewData={clientStories} title="Client Story" />
          </div>
        )}

        {showArticles && (
          <div className="articles-wrapper">
            <ArticleCard miniviewData={articles} title="Articles" />
          </div>
        )}

        {/* CTA Button */}
        {ctaText && ctaUrl && (
          <div className="case-studies-cta-section">
            <Button
              variant={"contained"}
              color="primary"
              size="large"
              label={ctaText}
              onClick={() => navigate(ctaUrl)}
              customClassName="info-view-resize-btn"
            />
          </div>
        )}
      </div>
    </section>
  );
};

export default CaseStudiesSection;
